import { render, staticRenderFns } from "./lowcodeFormPage.vue?vue&type=template&id=a915bab0&scoped=true"
import script from "./lowcodeFormPage.vue?vue&type=script&lang=js"
export * from "./lowcodeFormPage.vue?vue&type=script&lang=js"
import style0 from "./lowcodeFormPage.vue?vue&type=style&index=0&id=a915bab0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a915bab0",
  null
  
)

export default component.exports